/**
 * @Component
 * Component for Login page
 *
 */

import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from '../shared/services/auth.service';
import { ToastyService } from 'ng2-toasty';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {

  busy: Subscription;
  display: boolean = true;

  submitted: boolean = false;
  elements: any = {
    email: '',
    password: ''
  };

  element: any = {
      email: ''
  };

  displayFpwd: boolean = false;

  outdatedBrowserRework = require("outdated-browser-rework");

  // Set our navigation extras object
  // that passes on our global query params and fragment
  navigationExtras: NavigationExtras = {
    preserveQueryParams: true,
    preserveFragment: true
  };

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastyService: ToastyService
  ) {}


  ngOnInit() {
    let token = this.authService.tokenGet(this.authService.redirectUrl);
    if (token && this.authService.redirectUrl)
      this.router.navigate([this.authService.redirectUrl], this.navigationExtras);
    else if (token)
      this.router.navigate(['home'], this.navigationExtras);

    this.outdatedBrowserRework({
        browserSupport: {
            'Chrome': 37, // Includes Chrome for mobile devices
            'IE': 13,
            'Safari': 7,
            'Mobile Safari': 7,
            'Firefox': 32
        }
    });
  }

  /**
   * Triggered when submit button is clicked
   *
   * @return		void
   */
  tryToSubmit(): void {
    this.submitted = true;
  }

  /**
   * Save the current setting
   *
   * @return		void
   */
  submit(): void {
    this.busy = this.authService.login(this.elements).subscribe(user => {
      this.router.navigate([this.authService.redirectUrl ? this.authService.redirectUrl : '/home'], this.navigationExtras);
    });
  }

  tryToSendPwd(): void {

      this.busy = this.authService.forgotPwd({ "email": this.element.email }).subscribe(resp => {
          console.log(resp);
          //this.router.navigate([this.authService.redirectUrl]);
          this.displayFpwd = false;
          this.toastyService.success("Email envoyé sur votre boite mail");
      });
      //console.log("#TODO: redirect");
      //this.toastyService.info("#TODO: redirect");
  }

  showDialog() {
      this.displayFpwd = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts